
import {
  mapState,
  mapActions,
} from 'vuex'

import {
  addToComparison,
  removeFromComparison,
} from '@api/comparison.service'

export default {
  name: 'AddToComparison',
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState('comparison', [
      'comparison_ids',
    ]),
    is_added() {
      return id => this.comparison_ids.includes(id || this.id)
    },
  },
  methods: {
    ...mapActions('comparison', [
      'addId',
      'removeId',
    ]),
    async add(id) {
      await addToComparison.execute({}, { product: id || this.id })
      this.addId(this.id)
    },
    async remove(id) {
      try {
        await removeFromComparison.execute({ id: id || this.id })
        if (this.removeId) {
          console.log(this.id)
          this.removeId(this.id)
        } else {
          const index = this.comparison_ids.indexOf(this.id)
          if (-1 < index) {
            this.comparison_ids.splice(index, 1)
          }
        }

        this.$emit('remove', this.id)
      } catch (error) {
        console.error('Ошибка при удалении из сравнения:', error)
      }
    },
  },
  render() {
    window.umallAddToComparison = this.add
    window.umallIsInComparison = this.is_added
    window.umallRemoveFromComparison = this.remove
    return this.$scopedSlots.default({
      add: () => this.add(),
      remove: () => this.remove(),
      is_added: this.is_added(this.id),
    })
  },
}
